import {defaultState, TOGGLE_EVENT} from './reducer';
import {radiusSliderState} from '../slider/radiusSlider';
import {colors} from '../config';
import {isLayerAdded} from '../helpers';
import interaction from '../mobility/interaction';
import {map} from '../map/map';
import customConnect from '../customConnect';
import reducer from './reducer';
import overlay from '../popup/overlay';

import Style from 'ol/style/Style';
import Circle from 'ol/style/Circle';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import GeoJSON from 'ol/format/GeoJSON';

import { DefaultState } from './reducer';

import { setPopup } from '../popup/actions';

const ZOOM_LEVELS = [12,8,4];

var mapref = null;

var electricLayers = DefaultState.data;
var allModuleLayers = {};
var arrAllLayers = [];
var selectFeatureFunc = null;

for (var i = electricLayers.length - 1; i >= 0; i--) {

    for (var n = 1; n <= 3; n++) { 
        
        electricLayers[i].layer + 1;

        var layer = new VectorLayer({
            renderMode: 'image',
            style: function(feature) {

                var props = feature.getProperties();
                var pn = parseInt(props.paterins / 2000);
                var mod = 0.1 + 0.9 * (radiusSliderState.getPercent()/100);
                var radius = Math.sqrt(pn / Math.PI) * mod;

                return [new Style({
                        image: new Circle({
                          radius: radius,
                          stroke: new Stroke({
                            color: '#47556B',
                            opacity: 0.4,
                            width: 2.2
                          }),
                          fill: new Fill({
                            color: 'rgba(128, 169, 86, 0.7)' //'rgba(99, 148, 212, 1)',//'rgba(0,60,136,0.5)',
                          })
                        }),
                        zIndex: -pn
                })];
            },

            source: new VectorSource({
              format: new GeoJSON(),
              url: 'api?action=layer&layer=' + electricLayers[i].layer + '_' + n + '_level.geojson'
            //  features: (new ol.format.GeoJSON()).readFeatures({type: "FeatureCollection", crs:geojson.crs, features:geojson.features})
            })
        });

        if(typeof allModuleLayers[electricLayers[i].id] === 'undefined') {
            allModuleLayers[electricLayers[i].id] = [];
        }

        allModuleLayers[electricLayers[i].id][n-1] = layer;
        arrAllLayers.push(layer);
        electricLayers[i].olLayers.push(layer);
    }

}

/*
var timeout = false;
var refresh = function(){

    if(timeout) {
        clearTimeout(timeout);
    }

    timeout = setTimeout(function() {

        var style = layerPubTransp.getSource().getStyle();
        layerPubTransp.getSource().setStyle(style);

    }, THICKNESS_UPDATE_TIMEOUT);

}*/
/*
    layers: [layerPubTransp], 
        popupInst: overlay(),
        selectFeature: (feature)=> { selectFeature(feature, layerName) },
        styleActive: function(feature) {

            var props = feature.getProperties();

            return [
                new Style({
                    stroke: new Stroke({
                      lineCap: 'square', //round
                      lineJoin: 'bevel', //round
                      color: '#ffffff',
                      width: ((widthFunc(props))+1) * (lineThickSliderState.getPercent() / 100)
                    }),
                    zIndex: 1
                })
            ];
        }
*/

/*
ElectricUsageState.on(TOGGLE_EVENT, function() {

    var activeLayer = ElectricUsageState.getActiveGroup();

    for (var i = allModuleLayers.length - 1; i >= 0; i--) {
        
        if(isLayerAdded(allModuleLayers[i], mapref)) {
          mapref.removeLayer(allModuleLayers[i]);
        }
    }

    if(activeLayer) {

        for (var i = activeLayer.olLayers.length - 1; i >= 0; i--) {
            
            if(!isLayerAdded(activeLayer.olLayers[i], mapref)) {
              mapref.addLayer(activeLayer.olLayers[i]);
            }           
            
        }

        mapref.addInteraction(itrct);
        
    } else {

        mapref.removeInteraction(itrct);
    }
    
});*/

//lineThickSliderState.on('change', refresh);

var findZoomIndex = function(level) {

    for (var i = 0, len = ZOOM_LEVELS.length; i < len; i++) {

        if(ZOOM_LEVELS[i] < level) {

            return i;
        }
    }
}

var numberWithSpaces = function(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export default function(store) {

    var itrct = interaction({
        layers: arrAllLayers, 
        popupInst: overlay(),
        selectFeature: (feature) => {

            if(typeof selectFeatureFunc !== 'undefined') { 

                if(typeof feature[0] !== 'undefined') {
                    selectFeatureFunc(feature[0].getProperties()); 
                } else {
                    selectFeatureFunc(false); 
                }
                
            } 
        },
        styleActive: function(feature) {

            var props = feature.getProperties();
            var pn = parseInt(props.paterins / 2000);
            var mod = 0.1 + 0.9 * (radiusSliderState.getPercent()/100);
            var radius = Math.sqrt(pn / Math.PI) * mod;
                
            return [new Style({
                image: new Circle({
                  radius: radius,
                  stroke: new Stroke({
                    color: '#47556B',
                    opacity: 0.4,
                    width: 2.2
                  }),
                  fill: new Fill({
                    color: '#ffffff' //'rgba(99, 148, 212, 1)',//'rgba(0,60,136,0.5)',
                  })
                }),
                zIndex: 1
            })];
            
        }
    });

    var activeLayer = [];

    mapref = map;
//  map.addLayer(layerPubTransp);
    
    var oldZoom = null;
    mapref.on('moveend', function(){

        var zoomNew = mapref.getView().getZoom();
        if(zoomNew !== oldZoom) {

            console.log('zoomNew', zoomNew);

            var electricLayers = activeLayer;
            var zoomIndex = findZoomIndex(zoomNew);

            for (var i = electricLayers.length - 1; i >= 0; i--) {

                for(var n = 0; n < 3; n++) {
                    if(zoomIndex !== n) {
                        if(typeof allModuleLayers[electricLayers[i]] !== 'undefined' && typeof allModuleLayers[electricLayers[i]][zoomIndex] !== 'undefined') {
                            allModuleLayers[electricLayers[i]][zoomIndex].setVisible(false);
                        }
                    }
                }

                if(typeof allModuleLayers[activeLayer[i]][zoomIndex] !== 'undefined') {
                    allModuleLayers[activeLayer[i]][zoomIndex].setVisible(true);
                }
            }

            oldZoom = zoomNew;
        }
    });

   

    var stateUpdateHandler = function({active, data, selectFeature}) {

        activeLayer = data;
        selectFeatureFunc = selectFeature;

        for (var i = arrAllLayers.length - 1; i >= 0; i--) {
            
            if(isLayerAdded(arrAllLayers[i], mapref)) {
              mapref.removeLayer(arrAllLayers[i]);
            }
        }

        if(activeLayer.length > 0) {

            var zoomNew = mapref.getView().getZoom();

            for (var i = activeLayer.length - 1; i >= 0; i--) {
                
                var zoomIndex = findZoomIndex(zoomNew);

                if(!isLayerAdded(allModuleLayers[activeLayer[i]][zoomIndex], mapref)) {
                  mapref.addLayer(allModuleLayers[activeLayer[i]][zoomIndex]);
                }           
                
            }

            mapref.addInteraction(itrct);
            
        } else {

            mapref.removeInteraction(itrct);
        }
    }

    var mapStateToPropsRes = function(state) {

        var activeLayers = reducer.getActiveIds(state.electricUsage);

        return {
            active: (activeLayers.length > -1),
            data: activeLayers,
        }
    }

    var mapDispatchToPropsRes = function(dispatch) {

        return {
            selectFeature: (props) => {
                
                if(props !== null) {
                     dispatch(setPopup([
                        {name: 'Patēriņš', value: numberWithSpaces(Math.round(props.paterins)) + ' kWh' },
                    ]));
                } else {
                  dispatch(setPopup([]));
                }


            }
        }
    }


    customConnect(mapStateToPropsRes, mapDispatchToPropsRes, store, stateUpdateHandler);
}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/electricUsage/mapContainer.js